declare var angular: any;
import * as _ from 'underscore';
import * as moment from 'moment';
import { sortBy, kebabCase } from 'lodash';
import { Supports } from '../../../../../../../../libs/models/src';

/* Controllers */
angular
  .module('LessonControllers')

  .controller('LessonListCtrl', [
    '$scope',
    '$mdToast',
    'api',
    'lesson',
    '$window',
    function($scope, $mdToast, api, lesson, $window) {
      var getLessonUrl = lesson => {
        return kebabCase(lesson.title);
      };

      api.sync(api.getLessons, function(lessons) {
        $scope.lessons = sortBy(lessons, l =>
          String(l.title)
            .replace(/<[^>]+>/gm, '')
            .toLowerCase()
        ).map(l => {
          return {
            ...l,
            titleUrl: getLessonUrl(l.title)
          };
        });
        var stats = {
          known: 0,
          unknown: 0,
          inProgress: 0,
          total: lessons.length
        };

        for (var i = 0; i < lessons.length; i++) {
          if (lessons[i].known) {
            stats.known++;
          } else if (lessons[i].score > 2) {
            stats.inProgress++;
          } else if (lessons[i].score < -2) {
            stats.unknown++;
          }
        }
        $scope.stats = stats;
      });

      $scope.quickView = function(id, ev) {
        lesson.dialogDetail(id, ev);
      };

      $scope.updateCategory = function(label) {
        $scope.currentCategory = label;
      };

      if ($window.localStorage.dateOfRegister) {
        var freemiumExpiredDate = moment
          .utc(JSON.parse($window.localStorage.dateOfRegister))
          .add(1, 'days');
        $scope.isFreemium = moment.utc().isBefore(freemiumExpiredDate);
      }
    }
  ])

  .controller('LessonDetailCtrl', [
    '$scope',
    '$mdToast',
    '$routeParams',
    'navbar',
    'api',
    'share',
    'lesson',
    'EXAM',
    'exam',
    async function(
      $scope,
      $mdToast,
      $routeParams,
      navbar,
      api,
      share,
      lesson,
      EXAM,
      exam
    ) {
      if (EXAM === 'lerobert') {
        navbar.goBackAction('Règles', '#!cours');
      } else {
        navbar.goBackAction('Cours', '#!lesson', 'navbar.focus_langue');
      }

      const lessonId = parseInt($routeParams.lessonId, 10);

      if (exam.examData?.training?.lessons?.exercisesDisplay) {
        $scope.exercises = (await api.getExercicesFromLessonId(lessonId)).map(
          (l: Supports) => {
            return {
              ...l,
              instructions: l.instructions
                .replace(/Exemple.*/gm, '')
                .replace(/\<br\>/gm, '')
            };
          }
        );
      }

      $scope.share = function(title, description, url) {
        share.bottom(title, description);
      };

      api.sync(
        api.getLesson,
        function(lesson) {
          $scope.lesson = lesson;
          getBeforeAndNextLessons(lesson.category.id, lesson.id);
        },
        lessonId
      );

      // categoryTypeId to filtering lessons before searching
      function getBeforeAndNextLessons(categoryTypeId, lessonId) {
        api.sync(api.getLessons, function(lessons) {
          var categoryLessons = _.filter(lessons, function(l: any) {
            return l.category.id === categoryTypeId;
          });

          var currentLessonIndex = _.findIndex(categoryLessons, function(
            lesson
          ) {
            return lessonId === lesson.id;
          });

          $scope.previousLesson = categoryLessons[currentLessonIndex - 1];
          $scope.nextLesson = categoryLessons[currentLessonIndex + 1];
        });
      }

      $scope.currentLevel = function() {
        var mean = lesson.getPercentage($scope.lesson.score);

        if (mean >= 75) {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(71, 189, 17);';
          $scope.maskStyle =
            'transition: 1s linear all; height:' + (100 - mean) + 'px;';
          $scope.scoreStyle = 'transition: 1s linear all; color: #FFFFFF;';
        } else if (mean >= 50) {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(229, 245, 15);';
          $scope.maskStyle =
            'transition: 1s linear all; height:' + (100 - mean) + 'px;';
          $scope.scoreStyle = 'transition: 1s linear all; color: #000000;';
        } else if (mean >= 25) {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(255, 154, 2);';
          $scope.maskStyle =
            'transition: 1s linear all; height:' + (100 - mean) + 'px;';
        } else {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(235, 30, 7);';
          $scope.maskStyle =
            'transition: 1s linear all; height:' + (100 - mean) + 'px;';
        }
      };

      $scope.nextLevel = function() {
        var mean = lesson.getPercentage($scope.lesson.score);

        if (mean >= 75) {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(71, 189, 17);';
          $scope.maskStyle = 'transition: 1s linear all; height: 1px;';
        } else if (mean >= 50) {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(71, 189, 17);';
          $scope.maskStyle = 'transition: 1s linear all; height: 25px;';
          $scope.scoreStyle = 'transition: 1s linear all; color: #FFFFFF;';
        } else if (mean >= 25) {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(229, 245, 15);';
          $scope.maskStyle = 'transition: 1s linear all; height: 50px;';
        } else {
          $scope.gaugeStyle =
            'transition: 1s linear all; background-color: rgb(255, 154, 2);';
          $scope.maskStyle = 'transition: 1s linear all; height: 75px;';
        }
      };
    }
  ]);
